export default __webpack_public_path__ + "static/self-care-e786d406a0238415afee88f7af002fd7.webp";